export default __webpack_public_path__ + "static/media/4.f2a7f4ae.jpg";